import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { httpsCallable } from 'firebase/functions';
import { initAndGetFunctions } from './firebase';
import './Home.css';
import Form from './Form';
import { FormField } from './types/formTypes';
import Profile from  './Profile';
import LevitateAlex from './images/Levitate_Alex.jpg';
import LevitateCharlie from './images/Levitate_Charlie.jpg';
import LevitateDavid from './images/Levitate_David.jpg';
import LevitateDeniz from './images/Levitate_Deniz.jpg';
import LevitateFraser from './images/Levitate_Fraser.jpg';
import LevitateHalkwat from './images/Levitate_Halkwat.jpg';
import LevitateHaris from './images/Levitate_Haris.jpg';
import LevitateHarry from './images/Levitate_Harry.jpg';
import LevitateMert from './images/Levitate_Mert.jpg';
import LevitateSarkwat from './images/Levitate_Sarkwat.jpg';
import LevitateTommy from './images/Levitate_Tommy.jpg';
import HeroImage from './images/appHeroImage.png';

interface ProfileInfo {
  name: string;
  role: string;
  image: string;
}

// class FeatureInfo {
//   constructor(name, description) {
//     this.name = name;
//     this.description = description;
//   }
// }

interface HomeViewState {
  nppDialogOpen: boolean; // newsletter privacy policy dialog
  // contentChipSelected: string;
  // contentLoading: boolean;
}

// var chips = [];
// var contentTabs = new Map();
// var catNo = 0;

function Home() {
  const [state, setState] = useState<HomeViewState>({
    nppDialogOpen: false,
    // contentChipSelected: "ysCxKxM9SLFP2mV1h0lz",
    // contentLoading: true,
  });

  const newsletterFormFields: FormField[] = [
    {
      label: "Email Address",
      helpText: "e.g. joe.bloggs@gmail.com",
      type: "Email"
    }
  ];

  const profileInfo: ProfileInfo[] = [
    { name: "Halkwat", role: "CEO", image: `${LevitateHalkwat}` },
    { name: "Tommy", role: "COO", image: `${LevitateTommy}`},
    { name: "Sarkwat", role: "Finance Director", image: `${LevitateSarkwat}`},
    { name: "David", role: "IT Director", image: `${LevitateDavid}`},
    { name: "Deniz", role: "Production Director", image: `${LevitateDeniz}`},
    { name: "Alex", role: "Media", image: `${LevitateAlex}`},
    { name: "Charlie", role: "Production Assistant", image: `${LevitateCharlie}`},
    { name: "Fraser", role: "Web Developer", image: `${LevitateFraser}`},
    { name: "Harry", role: "Sales Director", image: `${LevitateHarry}`},
    { name: "Mert", role: "Marketing", image: `${LevitateMert}`},
    { name: "Haris", role: "Researcher", image: `${LevitateHaris}`}
  ];

  async function newsletterFormAction(fieldValues: string[]) {
    const functions = await initAndGetFunctions();
    const newsletterFunction = httpsCallable(functions, 'newsletter');
    return newsletterFunction({ email: fieldValues[0] });
  }

  useEffect(() => {
    
    // var firestore = firebase.firestore();
    
    // firestore.collection("advice").get().then((snapshot) => {
    //   chips = [];
    //   catNo = snapshot.docs.length;
    //   snapshot.forEach((doc) => {
    //       chips.push(<Chip id={doc.id} key={doc.id} label={doc.data().name} />);
    //       contentTabs.set(doc.id,
    //         <div className="profiles-list-container">
    //           <div className="content-list">
    //             {doc.data().articles.map((article) => {
    //               if (article.hidden == false) {
    //                 return <a href={`https://levitate.page.link/${article.id}`}>
    //                   <div className="content-container" key={article.id}>
    //                     <img src={article.thumbUrl} alt="Article thumbnail" className="content-image"></img>
    //                     <p>{article.name}</p>
    //                   </div>
    //                 </a>
    //               }
    //             })}
    //           </div>
    //         </div>
    //       );
    //   });
    // });
    
    // firestore.collection("podcasts").get().then((snapshot) => {
    //   if (chips.length == catNo) {
    //     chips.push(<Chip id="podcasts" key="podcasts" label="Mindfulness podcasts" />);
    //     contentTabs.set("podcasts",
    //       <div className="profiles-list-container">
    //         <div className="content-list">
    //           {snapshot.docs.map((doc) => {
    //             if (doc.data().hidden == false) {
    //               return <a href={`https://levitate.page.link/p-${doc.id}`}>
    //                 <div className="content-container" key={doc.id}>
    //                   <div style={{position: "relative"}}>
    //                     <img src={doc.data().thumbUrl} alt="Article thumbnail" className="content-image"></img>
    //                     <Fab className="podcast-fab" icon={<MaterialIcon icon="play_arrow" />} />
    //                   </div>
    //                   <p>{doc.data().title}</p>
    //                 </div>
    //               </a>
    //             }
    //           })}
    //         </div>
    //       </div>
    //     );
    //   }
    //   this.setState({contentLoading: false});
    // })
  }, []);

  // useEffect(() => { //TODO: test without this to see if we still need it
  //   var iframe = document.getElementById("features-iframe");
  //   if (iframe !== null) {
  //     iframe.src = "https://content.getlevitate.co.uk/iframe/features-slideshow.html";
  //   }
  // });

  return (
    <div className="App">
      <Dialog open={state.nppDialogOpen} aria-labelledby="npp-dialog-title" aria-describedby="npp-dialog-policy">
        <DialogTitle id="npp-dialog-title">Newsletter Privacy Policy</DialogTitle>
        <DialogContent>
          <DialogContentText id="npp-dialog-policy">This Privacy Policy describes how your personal information is collected, used, and shared when you sign up to the Levitate newsletter on getlevitate.co.uk or getlevitate.com (the “Site”). <br></br><br></br> <b>PERSONAL INFORMATION WE COLLECT</b> <br></br> When you enter your your email address into the newsletter signup form on our website, we collect your email address. Additionally, our newsletter signup form, embedded in our website, may automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. We refer to this information as “Collected Information.” <br></br><br></br> <b>HOW DO WE USE YOUR PERSONAL INFORMATION?</b> <br></br> We use the Personal Information that we collect to send you marketing emails about Levitate products to the email address you entered into the newsletter signup form. You may click the Unsubscribe button in any of our emails to stop receiving our marketing emails and to have your email address deleted from our records. <br></br><br></br> <b>SHARING YOUR PERSONAL INFORMATION</b> <br></br> We use SendGrid to send you marketing emails. This means means that we will share your email address with SendGrid so that they can store your email address and use your email address to send our marketing emails to you. For more information, you can find SendGrid's <a href="https://sendgrid.com/policies/privacy/services-privacy-policy">privacy policy.</a> <br></br><br></br> SendGrid is based in the United States. This means that, if you live outside of the United States, your Personal Information will be transferred to the United States. SendGrid has EU-U.S. Privacy Shield and Swiss-U.S. Privacy Shield certification. <br></br><br></br> Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights. <br></br><br></br> <b>YOUR RIGHTS</b> <br></br> You have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below. Additionally, we note that we are processing your information in order to pursue our legitimate business interests listed above.  Additionally, please note that if you live in Europe, your information will be transferred outside of Europe, including to Canada and the United States. <br></br><br></br> <b>DATA RETENTION</b> <br></br> When you enter your email address into our newsletter signup form, we will retain your email address for 6 months so that we can send you marketing emails for that time, or until you click the Unsubscribe button in one of our emails, in which case your email address will be deleted from our records then. <br></br><br></br> <b>MINORS</b> <br></br> The Site is not intended for individuals under the age of 18. We do not knowingly collect information from individuals under the age of 18. If you are under 18, you should not enter your email address into the newsletter signup form. If you are aware that an individual under the age of 18 has entered their email address into the newsletter signup form, please contact us using the contact details below and we will remove their details from our records swiftly. <br></br><br></br> <b>CHANGES</b> <br></br> We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons. Once the new privacy policy is posted on our website, it will become effective immediately, and you will be notified of the new privacy policy with an email. We encourage you to check our website regularly to check for updates. <br></br><br></br> <b>CONTACT US</b> <br></br> For more information about our privacy practices, if you have questions, or if you would like to make a complaint, or if you would like to exercise your rights under GDPR, please contact the Data Controller David Cannon by e-mail at <a href="mailto:david.cannon@getlevitate.co.uk">david.cannon@getlevitate.co.uk.</a></DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" onClick={() => setState({...state, nppDialogOpen: false})} color="secondary" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
      <div className="lev-card header-card home-header-card">
        <div className="home-header-card-left-col">
          <h1>Meet the Levitate app</h1>
          <p>Your mental-wellbeing-boosting toolkit, with a beautiful Journal, your favourite content together in Safe Haven and more.</p>
          <p className="home-header-card-promo">Coming this Summer</p>
          <a className="home-header-card-link" href="#newsletter">Sign up for updates <FontAwesomeIcon icon={faArrowCircleRight} /></a>
        </div>
        <div className="home-header-card-right-col">
          <img src={HeroImage} alt="The Levitate app"></img>
        </div>
      </div>
      <div className="lev-card features-card">
        <iframe id="features-iframe" title="features" src="https://content.getlevitate.co.uk/iframe/features-slideshow.html" scrolling="no"></iframe>
      </div>
      {/* <div className="lev-card">
        <h2>Available in the app</h2>
        <ChipSet choice selectedChipIds={this.state.contentChipSelected} handleSelect={(selected) => {this.setState({contentChipSelected: selected}); console.log(this.state.contentChipSelected)}}>
          {this.state.contentLoading ? <div id="loading"></div> : chips}
        </ChipSet>
        <br></br>
        {this.state.contentLoading ? <LinearProgress indeterminate /> : contentTabs.get(this.state.contentChipSelected[0])}
      </div> */}
      <div className="lev-card" id="newsletter">
        <h2>Sign up for updates</h2>
        <p>Interested in the Levitate app? Sign up to our newsletter to be notified when it's released and to get the latest news on Levitate.</p>
        <br></br>
        <Form fields={newsletterFormFields} actionName="Subscribe" action={newsletterFormAction} />
        <br></br>
        <Button className="npp-dialog-link" onClick={() => setState({...state, nppDialogOpen: true})}>
          <p>By clicking Subscribe you consent to us sending you marketing emails. Click or tap here for our full Privacy Policy.</p>
        </Button>
      </div>
      <div className="lev-card">
        <h2>The Levitate team</h2>
        <p>Mental health is sadly a huge problem both here in the UK and around the world, so in 2019, a handful of Edinburgh Academy students decided to try and do something about that by founding Levitate. Since then, our team have been busy making a high-quality leather notebook that you'll really want to use whenever you want to write your thoughts and feelings down, as well as a handy mobile app with a toolkit of activities designed to quickly boost your mental health. We're obsessive about quality and, with our expertise and knowledge of mental wellbeing as well as our personal experience, we've worked hard to bring you the best mental health products we can. We hope you enjoy our products and, if you're not having the best day, that our products help you feel better.</p>
        <br></br>
        <div className="profiles-list-container">
          <div className="profiles-list">
            {
              profileInfo.map((info) => {
                return <Profile name={info.name} key={info.name} role={info.role} image={info.image} />
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
